import { render } from "./vgooutmonad.vue?vue&type=template&id=994a9868&scoped=true"
import script from "./vgooutmonad.vue?vue&type=script&lang=js"
export * from "./vgooutmonad.vue?vue&type=script&lang=js"

import "./vgooutmonad.vue?vue&type=style&index=0&id=994a9868&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-994a9868"]])

export default __exports__